import { render, staticRenderFns } from "./BlankDocument.vue?vue&type=template&id=47000a78&scoped=true&functional=true&"
var script = {}
import style0 from "./BlankDocument.vue?vue&type=style&index=0&id=47000a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "47000a78",
  null
  
)

export default component.exports